import React from 'react'
import { Select, SelectOption } from 'ui'
import useQueryApiClient from 'utils/useQueryApiClient'
import { Validations } from 'interfaces'

interface EnumProps {
  id: number
  label: string
}

interface EnumSelectProps extends Validations {
  name?: (string | number)[] | string | number
  mode?: 'multiple' | 'tags'
  noStyle?: boolean
  label?: string
  disabled?: boolean
}

const EnumSelect = ({
  name,
  mode,
  validations,
  noStyle,
  label,
  disabled,
}: EnumSelectProps) => {
  const { data } = useQueryApiClient({
    request: {
      url: `api/v2/farms/activity-status`,
    },
  })

  return (
    <Select
      mode={mode}
      label={label}
      name={name}
      validations={validations}
      noStyle={noStyle}
      disabled={disabled}
    >
      {data.map((entry: EnumProps) => (
        <SelectOption key={entry.id} value={entry.id}>
          {entry.label}
        </SelectOption>
      ))}
    </Select>
  )
}

export default EnumSelect
